module.exports = "/_next/static/images/purple-hair-brown-hair-c521734d3722b4180e63db9b801b7c34.png";